function renderMenu(menuItems, baseUrl) {
    const menuwrapper = document.getElementById('my-page-menu');
    if (!menuwrapper) return;
    const menu = menuwrapper.querySelector('ul');
    if (!menu) return;

    // Clear the menu before adding new items
    menu.innerHTML = '';

    // Iterate over the menu items and create list items
    menuItems.forEach(item => {
        const listItem = document.createElement('li');
        const anchor = document.createElement('a');
        anchor.href = baseUrl + item.url;
        anchor.textContent = item.text;
        anchor.target = '_blank';
        listItem.appendChild(anchor);
        menu.appendChild(listItem);
    });

    menuwrapper.classList.remove("hidden");
    menuwrapper.classList.add("d-flex");
}
const myPageLink = document.getElementById("my-page");
const baseUrl = document.currentScript?.getAttribute("data-user-info-api");

// "Min side"-header finnes ikke på alle maler (f.eks. RtSm/SBR). Hopp ut hvis den mangler.
if (myPageLink && baseUrl) {
document.getElementById("my-page").setAttribute("href", baseUrl);
fetch(`${baseUrl}/api/userinfo`, {
    method: 'GET',
    credentials: 'include', // Ensure cookies are included in the request
})
    .then(response => response.json())
    .then(data => {
        if (data && data.isLoggedIn === true) {
            document.getElementById("my-page").classList.add("loggedIn");
            document.getElementById('user-info').innerHTML = data.userInfo?.firstName;

            if (data.topMenuLinks) {
                renderMenu(data.topMenuLinks, baseUrl);
            }
        }

    })
    .catch(error => console.error('Error:', error));
}